if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $('.awards-slider').slick({
        accessibility: true,
        arrows: true,
        slidesToShow: 2, 
        responsive: [
            {
                breakpoint: 768, 
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false
                }
            }
        ]
    });

    //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    $('.slider__slider').slick({
        arrows: true,
        dots: false,
        fade: true,
        draggable: false,
        accessibility: true,
        swipe: false,
        asNavFor: '.slider__slider-right',
        responsive:[
            {
                breakpoint: 600,
                settings: {
                    arrows:false,
                    dots:true,
                    asNavFor: null,
                    draggable: true,
                    swipe: true
                }
            }
        ]
    });

    $('.slider__slider-right').slick({
        arrows: false,
        dots: false,
        fade: true,
        accessibility: true,
        asNavFor: '.slider__slider'
    })

    $('.gallery-internal__slider').slick({
        arrows: true,
        dots: false,
        accessibility: true,
        fade: false,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });

    $('.gallery-quad__images').slick({
        arrows: true,
        dots: false,
        accessibility: true,
        fade: false,
        slidesToShow: 3,
        variableWidth: true,
        rtl: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 1,
                    variableWidth: true,
                    centerMode: true,
                    rtl: false
                }
            }
        ]
    })

     // WRAP MODULE TABLES
	document.querySelectorAll('.form-module-wrapper').forEach((form) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('form-module-wrapper__container','animate-fade','top');
        let confirmation = form.querySelector('.form-module__confirmation');
        let contentForm = form.querySelector('.form-module');
        form.appendChild(tableWrapper);
        tableWrapper.appendChild(confirmation);
        tableWrapper.appendChild(contentForm);
	});

    if(document.querySelector('.text-modules-wrapper')){
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    if(document.querySelector('.js-open-menu')){
        document.querySelector('.js-open-menu').addEventListener('click',()=>{
            document.querySelector('#menu-mobile').classList.add('show');
        })
    }

    if(document.querySelector('.close-menu')){
        document.querySelector('.close-menu').addEventListener('click', ()=>{
            document.querySelector('#menu-mobile').classList.remove('show');
        })
    }

    function capitalizeOptions() {
        const selectElement = document.getElementById('select_category_gallery');
        
        if (!selectElement) {
            console.warn('El elemento <select> con id "select_category_gallery" no existe.');
            return;
        }
    
        const options = selectElement.querySelectorAll('option');
    
        options.forEach(option => {
            option.textContent = option.textContent.toUpperCase();
        });
    }
    
    // Llamar la función
    capitalizeOptions();

})();